export const LAYOUT_STORAGE_VERSION = 2;

export interface PersistedLayout {
    v: typeof LAYOUT_STORAGE_VERSION;
    columnOrder?: string[];
    columnWidths?: Record<string, number>;
    columnVisibility?: Record<string, boolean>;
    groupCollapsed?: Record<string, boolean>;
    filters?: string;
    sort?: string;
    search?: string;
}

export interface PersistedQueryPatch {
    filters?: string;
    sort?: string;
    search?: string;
}

export interface TableSettings {
    layout: PersistedLayout;
    setWidth: (columnId: string, width: number) => void;
    setOrder: (columnIds: string[]) => void;
    setHidden: (columnId: string, hidden: boolean) => void;
    setGroupCollapsed: (groupKey: string, collapsed: boolean) => void;
    setQuery: (patch: PersistedQueryPatch) => void;
    reset: () => void;
}
